import { useState } from 'react';
import {
    Box,
    FormControl,
    FormErrorMessage,
    FormLabel,
    Stack,
    VStack,
} from '@chakra-ui/react';
import { Field } from 'formik';
import { Select } from 'chakra-react-select';
import FieldToolTip from 'components/forms/new/FieldToolTip';
import {
    formLabelStyling,
    stackSpacing,
    stackStyling,
    dropDownFormStyle,
} from 'components/forms/new/formStyles';
import { visibilityOptions } from '../consts';
import walkthroughIds from '../walkthroughIds';

const VisibilityField = ({ errors, touched, darkMode }) => {
    const [isHovered, setIsHovered] = useState(false);
    const chakraStyles = dropDownFormStyle(darkMode);

    return (
        <FormControl
            sx={{ margin: '0 !important' }}
            isInvalid={!!errors.visibility && touched.visibility}
            onMouseEnter={() => setIsHovered(true)}
            onMouseLeave={() => setIsHovered(false)}>
            <Stack direction="row" spacing={stackSpacing} sx={stackStyling()}>
                <FormLabel sx={formLabelStyling(darkMode)}>
                    Visibility <span style={{ color: '#e53e3e' }}>*</span>
                </FormLabel>
                <Field name="visibility">
                    {({ field, form }) => {
                        const selected =
                            visibilityOptions.find(
                                (o) => o.value === field.value,
                            ) || visibilityOptions[0];
                        return (
                            <Box
                                sx={{
                                    display: 'flex',
                                    width: '100%',
                                    alignItems: 'flex-start',
                                    paddingTop: '15px',
                                }}>
                                <VStack width="100%" alignItems="normal">
                                    <Select
                                        options={visibilityOptions}
                                        value={selected}
                                        onChange={(opt) =>
                                            form.setFieldValue(
                                                'visibility',
                                                opt?.value || 'visible',
                                            )
                                        }
                                        chakraStyles={chakraStyles}
                                        selectedOptionColor="brand"
                                        data-walkthroughid={
                                            walkthroughIds.createMode
                                                .ufVisibilitySelect
                                        }
                                    />
                                    {errors.visibility &&
                                        touched.visibility && (
                                            <FormErrorMessage
                                                sx={{
                                                    marginTop: '0 !important',
                                                    fontSize: '10px',
                                                }}
                                                justifyContent="flex-end">
                                                {errors.visibility}
                                            </FormErrorMessage>
                                        )}
                                </VStack>
                            </Box>
                        );
                    }}
                </Field>
                {isHovered && (
                    <FieldToolTip
                        label="Hidden offerings are excluded from customer-facing views."
                        ariaLabel="catalog-visibility-tip"
                        left="25px"
                        top="25px"
                    />
                )}
            </Stack>
        </FormControl>
    );
};

export default VisibilityField;
